import { createPaginator } from "@orange-marmalade/paginate-this";
import recordCollector from "LIB/recordCollector";
import createSearch from "MODULES/shared/actions/search";

function fetchList(list, getId) {
  return ({ query }) => (_, getState) => {
    const id = getId(getState());

    if (list.collect) {
      const endpoint = (page, limit) => list.api(id, { ...query, page, limit });

      return recordCollector(endpoint).then(results => ({
        data: {
          results,
          total_count: results.length
        }
      }));
    }

    return list.api(id, query);
  };
}

export function paginationGroup({ groupName, getId, locate }, ...definitions) {
  return definitions.map(def => {
    const { key, settings = {} } = def;
    return createPaginator({
      listId: `${groupName}/${key}`,
      fetch: fetchList(def, getId),
      locator: locate(def),
      maxPages: 15,
      ...settings
    });
  });
}

function debounce(asyncAction, ms = 300) {
  let timer = null;

  return (...args) => {
    clearTimeout(timer);

    return dispatch =>
      new Promise(resolve => {
        timer = setTimeout(() => {
          resolve(dispatch(asyncAction(...args)));
        }, ms);
      });
  };
}

export function createPaginatedList(options) {
  const {
    listId,
    fetch,
    stateLocator,
    forceDebounce,
    ...paginatorOptions
  } = options;
  const listSearch = createSearch(listId, fetch, stateLocator);

  const search = forceDebounce
    ? debounce(listSearch.search)
    : listSearch.search;

  return {
    ...listSearch,
    paginator: createPaginator({
      listId,
      fetch: search,
      locator: listSearch.stateLocator,
      ...paginatorOptions
    })
  };
}



// WEBPACK FOOTER //
// ./app/modules/shared/pagination.js